export function getCurrencyYear(state) {
    return state.currencyYear
}
